import React, {useState} from 'react';
import { Button, Card, Col, Row, Form, } from 'react-bootstrap';
import editing from 'assets/img/icons/spot-illustrations/21.png';
import { Link } from 'react-router-dom';
import FalconComponentCard from 'components/common/FalconComponentCard';
import Divider from 'components/common/Divider';
import LoaderInfiniteLoop from 'widgets/loaderInfiniteLoop';

import { Axios } from 'helpers/axios';
import HabilitationService from 'services/habilitationsService';

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { formStructureCreer } from 'helpers/yupValidationSchema';
import ConfigurationService from 'services/configurationService';

const NoStructure = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { register, handleSubmit, formState: { errors }, } = useForm({
        resolver: yupResolver(formStructureCreer),
    });

    const demanderCreation = async (data) => {
        try {
            setIsLoading(true);
            const response = await Axios.post('/authenticatedRoutes/structures/createStructure',{
                ...data
            });
            HabilitationService.saveCompleteSet({...response.data, seSouvenir: HabilitationService.seSouvenir});
            location.reload();
        } catch (error) {
            console.error(error)
        }
    }

    return (<>
        <Card>
            <Card.Body className="overflow-hidden p-lg-3">
                <Row className="align-items-center justify-content-between">
                    <Col lg={4}>
                        <img src={editing} className="img-fluid" alt="" />
                    </Col>
                    <Col lg={8} className="ps-lg-4 my-5 text-center text-lg-start">
                        <p className="lead">Votre compte est créé, c'est parfait ! Il faut maintenant vous rattacher à une structure organisatrice d'évènements (association, entreprise, club, ...) au nom de laquelle vous allez faire vos demandes de postes de secours.</p>
                        <FalconComponentCard>
                            <FalconComponentCard.Header
                                title='Se rattacher'
                                noPreview={true}
                            />
                            <FalconComponentCard.Body>
                                Votre structure existe déjà dans notre base ? Ne la créez surtout pas en doublon, demandez à un membre existant de votre structure de vous y rattacher.
                                Si vous rencontrez des soucis, vous pouvez toujours <Link to={"/contact"}>nous contacter.</Link>
                            </FalconComponentCard.Body>
                        </FalconComponentCard>

                        <Divider>ou</Divider>

                        <FalconComponentCard>
                            <FalconComponentCard.Header
                                title='Créer'
                                noPreview={true}
                            />
                            <FalconComponentCard.Body>
                                {ConfigurationService.config['creationStructureAutonomeClient'] ? <>
                                    <center className='mb-3'><i>Vous êtes le premier utilisateur de votre structure ? Utilisez le formulaire ci-dessous pour la créer !</i></center>
                                    {isLoading ?
                                        <LoaderInfiniteLoop />
                                    :
                                        <Form onSubmit={handleSubmit(demanderCreation)}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Raison sociale <small>(Nom de l'association, entreprise, club)</small></Form.Label>
                                                <Form.Control size="sm" type="text" name="nomStructureClient" id="nomStructureClient" {...register('nomStructureClient')} isInvalid={!!errors.nomStructureClient}/>
                                                <small className="text-danger">{errors.nomStructureClient?.message}</small>
                                            </Form.Group>

                                            <Form.Group className="mb-2">
                                                <Form.Label>Adresse complète</Form.Label>
                                                <Form.Control as="textarea" rows={4} name="adresseStructureClient" id="adresseStructureClient" {...register("adresseStructureClient")}  isInvalid={!!errors.adresseStructureClient}/>
                                                <small className="text-danger">{errors.adresseStructureClient?.message}</small>
                                            </Form.Group>

                                            <hr/>

                                            <Row>
                                                <Col md="6">
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Représentant Légal <small>Nom, Prénom</small></Form.Label>
                                                        <Form.Control type="text" name="representantLegalStructureClient" id="representantLegalStructureClient" {...register("representantLegalStructureClient")} isInvalid={!!errors.representantLegalStructureClient}/>
                                                        <small className="text-danger">{errors.representantLegalStructureClient?.message}</small>
                                                    </Form.Group>
                                                </Col>
                                                <Col md="6">
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Fonction</Form.Label>
                                                        <Form.Control type="text" name="representantLegalFonctionStructureClient" id="representantLegalFonctionStructureClient" {...register("representantLegalFonctionStructureClient")} isInvalid={!!errors.representantLegalFonctionStructureClient}/>
                                                        <small className="text-danger">{errors.representantLegalFonctionStructureClient?.message}</small>
                                                    </Form.Group>
                                                </Col>
                                                <Col md="6">
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Adresse email</Form.Label>
                                                        <Form.Control type="text" name="representantLegalMailStructureClient" id="representantLegalMailStructureClient" {...register("representantLegalMailStructureClient")} isInvalid={!!errors.representantLegalMailStructureClient}/>
                                                        <small className="text-danger">{errors.representantLegalMailStructureClient?.message}</small>
                                                    </Form.Group>
                                                </Col>
                                                <Col md="6">
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Téléphone</Form.Label>
                                                        <Form.Control type="text" name="representantLegalTelStructureClient" id="representantLegalTelStructureClient" {...register("representantLegalTelStructureClient")} isInvalid={!!errors.representantLegalTelStructureClient}/>
                                                        <small className="text-danger">{errors.representantLegalTelStructureClient?.message}</small>
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <hr/>

                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Adresse email pour la facturation</Form.Label>
                                                        <Form.Control type="text" name="facturationMailStructureClient" id="facturationMailStructureClient" {...register("facturationMailStructureClient")} isInvalid={!!errors.facturationMailStructureClient}/>
                                                        <small className="text-danger">{errors.facturationMailStructureClient?.message}</small>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Téléphone du contact pour la facturation</Form.Label>
                                                        <Form.Control type="text" name="facturationTelStructureClient" id="facturationTelStructureClient" {...register("facturationTelStructureClient")} isInvalid={!!errors.facturationTelStructureClient}/>
                                                        <small className="text-danger">{errors.facturationTelStructureClient?.message}</small>
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <Button variant='primary' className='mt-3 mb-1 w-100' type="submit" disabled={isLoading}>{isLoading ? 'Patientez...' : 'Créer ma structure'}</Button>
                                        </Form>
                                    }
                                </>:<>
                                    Vous êtes le premier utilisateur de votre structure ? Il va falloir la créer ! Malheureusement, la fonctionnalité de création de structure est temporairement indisponible depuis votre compte client.{' '}
                                    Ce n'est pas grave, <Link to={"/contact"}>contactez nous !</Link>
                                </>}
                            </FalconComponentCard.Body>
                        </FalconComponentCard>
                    </Col>
                </Row>
            </Card.Body>
        </Card> 
    </>);
};

export default NoStructure;